/** @jsx jsx */
import { jsx, useThemeUI, Flex, Box } from "theme-ui";
import React from "react";
import { withI18n } from "@lingui/react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useForm } from "react-hook-form";
import Button from "components/Button/Button";
import { Trans, t } from "@lingui/macro";
import { useAppSettings } from "providers/AppSettingsProvider/AppSettingsProvider";
import Select from "components/Form/Select";
import { useAuthentication } from "providers/AuthenticationProvider/AuthenticationProvider";
import Loading from "components/Loading/Loading";
import { getBWColorFromContext } from "theme";
import LanguageSwitcher from "components/LanguageSwitcher/LanguageSwitcher";
import { I18n } from "@lingui/core";
import keycloak, { KEYCLOAK_SCOPE } from "keycloak";
export interface LoginProps {
    i18n: I18n;
}

const Login: React.FC<LoginProps> = ({ i18n }) => {
    const { isAuthInProgress } = useAuthentication();

    const appSettings = useAppSettings();

    const context = useThemeUI();
    const { theme } = context;

    return (
        <Flex
            sx={{
                width: "100%",
                height: "100%",
                justifyContent: "center",
                alignItems: "center",
            }}
        >
            <Flex sx={{ maxWidth: "960px", width: "100%" }}>
                <Flex
                    sx={{
                        flexDirection: "column",
                        margin: 20,
                        width: "100%",
                    }}
                >
                    <FontAwesomeIcon
                        size="5x"
                        icon={["fas", "plug"]}
                        style={{ color: `${theme.colors?.primary}` }}
                    />
                    <h4>
                        <Trans id="login.loginWithYourAccount">
                            Var god logga in med ditt kioskkonto
                        </Trans>
                    </h4>
                    <h1>
                        <Trans id="login.heading">Anslut kiosk</Trans>
                    </h1>
                </Flex>
                <Flex
                    sx={{
                        flexDirection: "column",
                        margin: 20,
                        width: "100%",
                    }}
                >
                    <form
                        onSubmit={(evt) => {
                            evt.preventDefault();
                        }}
                    >
                        <Box>
                            <Flex sx={{ justifyContent: "flex-end" }}>
                                <LanguageSwitcher show />
                            </Flex>
                        </Box>
                        <Select
                            style={{ margin: "15px 0px" }}
                            value={appSettings?.UseCase}
                            onChange={(val) => {
                                appSettings?.setAppSettings({
                                    ...appSettings,
                                    UseCase: val.toLocaleLowerCase(),
                                    Theme: appSettings?.OverrideTheme
                                        ? appSettings?.Theme.toLocaleLowerCase()
                                        : val === "washing"
                                            ? "poppy"
                                            : "eco",
                                    Typography: appSettings?.OverrideTheme
                                        ? appSettings?.Theme.toLocaleLowerCase()
                                        : val === "washing"
                                            ? "poppy"
                                            : "bokamera",
                                });
                            }}
                            items={[
                                {
                                    value: "conference",
                                    text: i18n._(t("appSettings.useCase.conference")``),
                                },
                                {
                                    value: "washing",
                                    text: i18n._(t("appSettings.useCase.washing")``),
                                },
                            ]}
                        />
                        <Button
                            style={{ minWidth: "100%" }}
                            htmlType="button"
                            onTouchEnd={() => {
                                keycloak.login({ scope: KEYCLOAK_SCOPE })

                            }}
                            onClick={() => {
                                keycloak.login({ scope: KEYCLOAK_SCOPE })
                            }}
                        >
                            {isAuthInProgress ? (
                                <Loading
                                    color={getBWColorFromContext(theme?.colors?.primary)}
                                    style={{ marginTop: 0 }}
                                    size={20}
                                />
                            ) : (
                                <Trans id="login.action" />
                            )}
                        </Button>
                    </form>
                </Flex>
            </Flex>
        </Flex>
    );
};

export default withI18n()(Login);
